import {createSelector} from "@reduxjs/toolkit";

import {clientValuationsApi} from "#app/api/clients/clientValuationsRtk";
import type { RootState } from "#app/store/types/rootState";
const selectClientValuationsState = (state: {clientValuations: import("#app/store/RTK/slices/clientValuationsSlice").ClientValuationsState}) =>
    state.clientValuations;

export const selectClientValuationById = createSelector(
    [selectClientValuationsState, (_state: any, clientId: number | string | null | undefined) => clientId],
    (slice, clientId) => {
        if (clientId == null) {
            return undefined;
        }
        return slice.byClientId[String(clientId)];
    }
);

export const selectClientValuationsPreloadStatus = (state: {clientValuations: {preloadStatus: string}}) =>
    state.clientValuations.preloadStatus;

export const selectManagerValuationsQuery = (state: RootState, managerId: number | undefined) =>
    clientValuationsApi.endpoints.getManagerTodayValuations.select(
        managerId ? {managerId} : ({managerId: 0} as {managerId: number})
    )(state as any);

export const selectIsClientValuationLoading = (
    state: RootState,
    managerId: number | undefined
): boolean => {
    if (!managerId) {
        return false;
    }
    const preloadStatus = (state as { clientValuations?: { preloadStatus?: string } }).clientValuations
        ?.preloadStatus;
    if (preloadStatus === 'loading') {
        return true;
    }
    return Boolean(selectManagerValuationsQuery(state, managerId)?.isLoading);
};
